import ApiService from "@/services/Api"

type EligibilityResponse = {
	eligible: boolean
}

type SubmitData = {
	name: string
	phone: string
}

class AccountOwnerContactUpdateService {
	async checkEligibility (): Promise<EligibilityResponse> {
		const { data } = await ApiService.get<EligibilityResponse>("/account/owner-contact-update/eligibility")
		return data
	}

	async submit (data: SubmitData): Promise<void> {
		await ApiService.post("/account/owner-contact-update/submit", data)
	}

	async expire (): Promise<void> {
		await ApiService.post("/account/owner-contact-update/expire")
	}
}

export default new AccountOwnerContactUpdateService()
